export enum TableRendererEnum {
  Default = 'default',
  SimpleBar = 'simplebar',
  Image = 'image',
  DistributionChart = 'distributionChart',
  Link = 'link',
}
